var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgVisablue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1920.01 620.08",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #1434cb;\n        stroke-width: 0px;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M729,10.96l-251.37,599.74h-164l-123.7-478.62c-7.51-29.48-14.04-40.28-36.88-52.7C115.76,59.15,54.18,40.17,0,28.39L3.68,10.96h263.99c33.65,0,63.9,22.4,71.54,61.15l65.33,347.04L566,10.95h163ZM1371.58,414.89c.66-158.29-218.88-167.01-217.37-237.72.47-21.52,20.96-44.4,65.81-50.24,22.23-2.91,83.48-5.13,152.95,26.84l27.25-127.18c-37.33-13.55-85.36-26.59-145.12-26.59-153.35,0-261.27,81.52-262.18,198.25-.99,86.34,77.03,134.52,135.81,163.21,60.47,29.38,80.76,48.26,80.53,74.54-.43,40.23-48.23,57.99-92.9,58.69-77.98,1.2-123.23-21.1-159.3-37.87l-28.12,131.39c36.25,16.63,103.16,31.14,172.53,31.87,162.99,0,269.61-80.51,270.11-205.19M1776.52,610.7h143.49L1794.76,10.96h-132.44c-29.78,0-54.9,17.34-66.02,44l-232.81,555.74h162.91l32.34-89.58h199.05l18.73,89.58ZM1603.41,398.2l81.66-225.18,47,225.18h-128.66ZM950.67,10.96l-128.29,599.74h-155.14L795.58,10.96h155.09Z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisablue);
export default __webpack_public_path__ + "static/media/Visa blue.8e53c9660b0ac074e5b521afd4a9d0dc.svg";
export { ForwardRef as ReactComponent };